import { create } from "zustand";

type DialogState = {
  dialogs: Record<string, boolean>;
  openDialog: (dialogId: string) => void;
  closeDialog: (dialogId: string) => void;
};

export const useDialogStore = create<DialogState>((set) => ({
  dialogs: {},
  openDialog: (dialogId: string) =>
    set((state) => ({
      dialogs: { ...state.dialogs, [dialogId]: true },
    })),
  closeDialog: (dialogId: string) =>
    set((state) => ({
      dialogs: { ...state.dialogs, [dialogId]: false },
    })),
}));
